module.exports = __webpack_public_path__ + "static/member-2-131ec49dccd224227821049fa1e47a37.jpg";